/**
 * There are two types of wait: implicit and explicit.
 * - Explicit waits are waits that you explicitly tell to start and stop with
 *   the explicit wait actions. Examples include switching tasks in a lesson
 *   and the loading message that appears in parent portal.
 * - Implicit waits are waits that appear automatically if code called in a
 *   wCall within a saga takes a little while to run.
 */

import { combineReducers } from 'redux-immutable';

import { implicitWaitReducer } from './implicit-wait-reducer';
import { explicitWaitReducer } from './explicit-wait-reducer';

export const WAIT_KEY = 'wait';

export const waitReducer = combineReducers({
    ['implicit']: implicitWaitReducer,
    ['explicit']: explicitWaitReducer,
});
